import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { isAuthenticated } from '../../../modules/user/selectors';
import NoBetsAnonymous from './NoBetsAnonymous';
import NoBetsAuthenticated from './NoBetsAuthenticated';

const mapStateToProps = state => ({
  authenticated: isAuthenticated(state),
});

export const NoBets = ({ authenticated }) => (
  <div className="open-bets">
    <div className="open-bets-list">
      <div className="container--fixed">
        {(authenticated) ? <NoBetsAuthenticated /> : <NoBetsAnonymous />}
      </div>
    </div>
  </div>
);

NoBets.propTypes = {
  authenticated: PropTypes.bool
};

export default connect(mapStateToProps)(NoBets);
